import React from 'react';
import { useTranslation } from 'react-i18next';
import { LayoutTestIds, getCssVariable } from '@ab-inbev/sam-utils';
import { OfflineIcon } from '@ab-inbev-labs/ux-react-components';

export const OfflineIndicator = () => {
  const i18next = useTranslation();
  return (
    <div className="offline-indicator" data-testid={LayoutTestIds.OfflineIndicator}>
      <div>
        <OfflineIcon color={getCssVariable('--color-feedback-danger-400')} />
      </div>{' '}
      <div className="offline-indicator-text">{i18next.t('common.labels.offline')}</div>
    </div>
  );
};
